import * as React from 'react';
import { LayoutDashboard } from '../../../shared/layouts';


export const Analytics: React.FC = () => {

    return (
        <React.Fragment>
            <LayoutDashboard title='Analytiics'>

            </LayoutDashboard>
        </React.Fragment>
    );
};

